export const convertArrayToDate = (dateArray?: number[]) => (dateArray ? dateArray.slice(0, 6).join('-') : '');
